import store from 'store';

import { setDidomiUserStatus } from 'store/config/actions';

export async function updateConsent() {
    const currentUserStatus = window.Didomi?.getCurrentUserStatus();

    if (currentUserStatus) {
        store.dispatch(setDidomiUserStatus(currentUserStatus));
    }
}
